import { createRouter, createWebHistory } from 'vue-router'
import { jetons } from '@/api/client'

// `meta.public` marque les deux écrans accessibles sans session : demander
// un lien, et le consommer. Tout le reste exige un jeton — on ne peut pas
// demander une session pour en ouvrir une.
const routes = [
  { path: '/', redirect: '/tableau-de-bord' },
  {
    path: '/connexion',
    name: 'demande-lien',
    component: () => import('@/views/DemandeLien.vue'),
    meta: { public: true },
  },
  {
    path: '/connexion/:token',
    name: 'connexion',
    component: () => import('@/views/Connexion.vue'),
    meta: { public: true },
  },
  {
    // Aperçu administrateur. Publique au sens du garde — le jeton EST
    // dans l'adresse — mais elle n'ouvre rien par elle-même : c'est
    // l'API qui décide, et le jeton ne vaut que dix minutes, en lecture.
    path: '/apercu/:token',
    name: 'apercu',
    component: () => import('@/views/Apercu.vue'),
    meta: { public: true },
  },
  { path: '/tableau-de-bord', name: 'tableau-de-bord', component: () => import('@/views/TableauDeBord.vue') },
  { path: '/contrats', name: 'contrats', component: () => import('@/views/Contrats.vue') },
  { path: '/factures', name: 'factures', component: () => import('@/views/Factures.vue') },
  { path: '/documents', name: 'documents', component: () => import('@/views/Documents.vue') },
  { path: '/demandes', name: 'demandes', component: () => import('@/views/Demandes.vue') },
  { path: '/profil', name: 'profil', component: () => import('@/views/Profil.vue') },
  // Toute autre adresse ramène à l'accueil plutôt que sur un écran blanc.
  { path: '/:chemin(.*)', redirect: '/tableau-de-bord' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(to => {
  const connecte = !!jetons.acces()
  if (!to.meta.public && !connecte) return { name: 'demande-lien' }
  // Déjà connecté : la page de demande de lien n'a plus d'objet. On ne
  // redirige PAS depuis `/connexion/:token`, qui doit pouvoir ouvrir une
  // nouvelle session même si une ancienne traîne.
  if (to.name === 'demande-lien' && connecte) return { name: 'tableau-de-bord' }
  // Comme `/connexion/:token`, l'aperçu doit pouvoir s'ouvrir même si
  // une session traîne : un administrateur en enchaîne plusieurs.
  if (to.name === 'apercu') return true
  return true
})

export default router
